var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showForm)?_c('gmh-login',{attrs:{"no-redirect":true,"redirect-to":"profile-page","settings":_vm.settings,"translations":_vm.translations}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }